/*
 * ██████╗ ██╗████████╗███████╗ █████╗  ██████╗████████╗ ██████╗ ██████╗ ██╗   ██╗
 * ██╔══██╗██║╚══██╔══╝██╔════╝██╔══██╗██╔════╝╚══██╔══╝██╔═══██╗██╔══██╗╚██╗ ██╔╝
 * ██████╔╝██║   ██║   █████╗  ███████║██║        ██║   ██║   ██║██████╔╝ ╚████╔╝
 * ██╔══██╗██║   ██║   ██╔══╝  ██╔══██║██║        ██║   ██║   ██║██╔══██╗  ╚██╔╝
 * ██████╔╝██║   ██║   ██║     ██║  ██║╚██████╗   ██║   ╚██████╔╝██║  ██║   ██║
 * ╚═════╝ ╚═╝   ╚═╝   ╚═╝     ╚═╝  ╚═╝ ╚═════╝   ╚═╝    ╚═════╝ ╚═╝  ╚═╝   ╚═╝
 *
 *
 * Copyright (c) Bitfactory GmbH. All rights reserved.
 * https://www.bitfactory.io
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are not permitted.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS
 * FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE
 * COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT,
 * INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES INCLUDING,
 * BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
 * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
 * CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT
 * LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN
 * ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 * POSSIBILITY OF SUCH DAMAGE.
 */

import { Message } from '../types/Message';
import axios from 'axios';
import { getUrl } from '../utils/helper';

const privateRoomRegEx = /(([A-Za-z0-9]+)-([A-Za-z0-9]+)-([A-Za-z0-9]+))/;
const publicRoomRegEx = /([A-Za-z0-9]+)/;
const privateRoomPath = 'private-messages/room/';
const publicRoomPath = 'group-messages/course/';

export class ChatService {
	public getMessages(token: string, room: string): Promise<Message[]> {
		let path = '';
		if (room.match(privateRoomRegEx)) {
			path = privateRoomPath + room;
		} else if (room.match(publicRoomRegEx)) {
			path = publicRoomPath + room;
		} else {
			throw 'Room Format wrong!';
		}

		return axios
			.get<Message[]>(`${getUrl()}/${path}`, {
				headers: {
					Authorization: `Bearer ${token}`,
				},
			})
			.then((res) => {
				return res.data;
			});
	}

	public setMessagesAsRead(token: string, room: string): Promise<void> {
		let path = '';
		if (room.match(privateRoomRegEx)) {
			path = 'private-messages';
		} else if (room.match(publicRoomRegEx)) {
			path = 'group-messages';
		} else {
			throw 'Room Format wrong!';
		}

		return axios.get(`${getUrl()}/${path}/setMessagesAsRead/${room}`, {
			headers: {
				Authorization: `Bearer ${token}`,
			},
		});
	}
}
